import React, { Component } from 'react';

import Input from './Input';
import Select from './Select';
import Checkbox from './Checkbox';
import Autocomplete from './Autocomplete';

class FormTable extends Component {
    render() {
        return (
            <div className="pp-form-wrapper">

                <div className="pp-form-row">
                    <Input label="Input Field" placeholderText="Placeholder text" />
                </div>

                <div className="pp-form-row pp-error">
                    <p className="pp-error-message">This is a form field error message.</p>
                    <Input label="Input Field" />
                </div>

                <div className="pp-form-row">
                    <Input label="Input Field" placeholderText="Placeholder text" disabled defaultValue="This field is disabled" />
                </div>

                <div className="pp-form-row">
                    <Input type="password" label="Password" defaultValue="password" />
                </div>

                <div className="pp-form-row">
                    <Input type="number" label="Number" />
                </div>

                <div className="pp-form-row">
                    <Input type="email" label="Email" />
                </div>

                <div className="pp-form-row">
                    <Select label="Select" />
                </div>

                <div className="pp-form-row-split">
                    <Input label="Input Field" />
                </div>

                <div className="pp-form-row-split">
                    <Input label="Input Field" />
                </div>
                <div className="pp-form-row">
                    <Input label="Input Field" />
                </div>

                <div className="pp-form-row">
                    <Checkbox label="This is another style of input, you can add a really long label to it." />
                </div>

                <div className="pp-form-row-double">
                    <Input label="There are two inputs" />
                    <Select label="Select" />
                </div>

                <div className="pp-form-row">
                    <Autocomplete label="Input Field" placeholderText="Placeholder text" />
                </div>

            </div>
        );
    }
}

export default FormTable;



// WEBPACK FOOTER //
// ./src/components/FormTable.js